// extracted by mini-css-extract-plugin
module.exports =  {"tc-resource-picker":"ResourcePicker-module__tc-resource-picker___XZnuh"};